(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-tabs"] && !Shopify.designMode) return;
  try {
    
/* ── CctTabs : tab switching ───────────────────────────── */
class CctTabs extends HTMLElement {
  connectedCallback() {
    this._tabs   = Array.from(this.querySelectorAll('.custom-collection-tabs__tab'));
    this._panels = Array.from(this.querySelectorAll('.custom-collection-tabs__panel'));
    this._count  = this.querySelector('.custom-collection-tabs__count');

    this._tabs.forEach(tab => tab.addEventListener('click', () => this._activate(tab)));

    const sortSelect = this.querySelector('[data-section-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', (e) => this._onSort(e.target.value));
    }
  }

  _activate(tab) {
    const idx = tab.dataset.tab;

    this._tabs.forEach(t => {
      t.classList.remove('is-active');
      t.setAttribute('aria-selected', 'false');
    });
    tab.classList.add('is-active');
    tab.setAttribute('aria-selected', 'true');

    this._panels.forEach(panel => panel.setAttribute('hidden', ''));
    const panel = this.querySelector(`[data-count][id$="-${idx}"]`);
    if (panel) {
      panel.removeAttribute('hidden');
      if (this._count) {
        this._count.textContent = `${panel.dataset.count} products`;
      }
      /* Reset carousel scroll */
      const track = panel.querySelector('[data-carousel-track]');
      if (track) track.scrollLeft = 0;
      /* Refresh arrow states */
      const carousel = panel.querySelector('[data-carousel]');
      if (carousel) CctCarousel.refresh(carousel);
    }
  }

  _onSort(sortBy) {
    /* Navigate to active collection with sort param */
    const activeTab = this._tabs.find(t => t.classList.contains('is-active'));
    if (!activeTab) return;
    const panel = this.querySelector(`[data-count][id$="-${activeTab.dataset.tab}"]`);
    if (!panel) return;
    const link = panel.querySelector('a[href]');
    if (!link) return;
    const url = new URL(link.href, window.location.origin);
    url.searchParams.set('sort_by', sortBy);
    window.location.href = url.toString();
  }
}
customElements.define('cct-tabs', CctTabs);

/* ── CctCarousel : prev/next arrows ───────────────────── */
const CctCarousel = {
  init(el) {
    const track  = el.querySelector('[data-carousel-track]');
    const prev   = el.querySelector('[data-carousel-prev]');
    const next   = el.querySelector('[data-carousel-next]');
    const dotsEl = el.querySelector('[data-carousel-dots]');
    if (!track) return;

    const slides = Array.from(track.querySelectorAll('.cct-carousel__slide'));

    /* ── Dots de pagination ─────────────────────────────── */
    if (dotsEl && slides.length > 1) {
      slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.className = 'cct-carousel__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', `Slide ${i + 1}`);
        dot.addEventListener('click', () => {
          const sw = slides[0] ? slides[0].offsetWidth + parseFloat(getComputedStyle(track).gap || 0) : 0;
          track.scrollTo({ left: i * sw, behavior: 'smooth' });
        });
        dotsEl.appendChild(dot);
      });
    }

    /* ── Arrows + dots update ───────────────────────────── */
    const update = () => {
      const atStart = track.scrollLeft <= 4;
      const atEnd   = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 4;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;

      if (dotsEl && slides.length > 1) {
        const sw = slides[0] ? slides[0].offsetWidth + parseFloat(getComputedStyle(track).gap || 0) : 1;
        const active = Math.round(track.scrollLeft / sw);
        dotsEl.querySelectorAll('.cct-carousel__dot').forEach((dot, i) => {
          dot.classList.toggle('is-active', i === active);
        });
      }
    };

    const slideWidth = () => {
      const slide = track.querySelector('.cct-carousel__slide');
      return slide ? slide.offsetWidth + parseFloat(getComputedStyle(track).gap || 0) : 280;
    };

    if (prev) prev.addEventListener('click', () => {
      track.scrollBy({ left: -slideWidth() * 2, behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', () => {
      track.scrollBy({ left: slideWidth() * 2, behavior: 'smooth' });
    });

    track.addEventListener('scroll', update, { passive: true });
    update();
  },

  refresh(el) {
    const track = el.querySelector('[data-carousel-track]');
    const prev  = el.querySelector('[data-carousel-prev]');
    const next  = el.querySelector('[data-carousel-next]');
    if (!track) return;
    const atStart = track.scrollLeft <= 4;
    const atEnd   = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 4;
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
  }
};

document.querySelectorAll('[data-carousel]').forEach(CctCarousel.init.bind(CctCarousel));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
